import React from 'react';
// Style
import styles from './style/loadingContent.module.css';

const LoadingContent = ({ lineNumber, loading, title }:{ lineNumber?:number, loading?:boolean, title?:boolean }) => (
  <div className={`${styles.loadingContent} ${loading ? styles.loadingContent_loading : ''}`}>
    { title && (<span className={styles.loadingContent__title} />)}
    {[...Array(lineNumber)].map((e, i) => <span key={i.toString()} />)}
  </div>
);

LoadingContent.defaultProps = {
  lineNumber: 3,
  loading: false,
  title: true,
};

export default LoadingContent;
